import React from "react";
import {GameInfo} from "../../../services/games/game-info";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {LiveStreamingTileComponent} from "../../live-streaming-tile/live-streaming-tile.component";
import {LiveStreamingItemContainerBox} from "./boxes/live-streaming-item-container.box";

export interface SingleGameLiveStreamingTemplateProps {
    tableConfig: GameInfo;
    onOpenRealGame: () => void;
}
export class SingleGameLiveStreamingTemplate extends OrbitComponent<SingleGameLiveStreamingTemplateProps> {
    render() {
        return (
            <LiveStreamingItemContainerBox>
                <LiveStreamingTileComponent
                    gameInfo={this.props.tableConfig}
                    onOpenRealGame={this.props.onOpenRealGame}
                />
            </LiveStreamingItemContainerBox>
        );
    }
}